// Module
var code = "<style>:host{display:inline-block;min-width:24px;min-height:24px}div{display:inline-block}#trend-wrapper{padding-left:5px;display:none;height:1em;margin:auto;font-size:.5em}</style> <div id=\"value\"></div> <div id=\"trend-wrapper\"> <div id=\"arrow\">▲</div> <div id=\"trend-value\"></div> </div> ";
// Exports
export default code;